import React from 'react';
import { CheckCircle2, Users, Wrench, Eye, Calendar } from 'lucide-react';
import { aboutContent, companyInfo } from '../data/mock';

const iconMap = {
  'Personal Calificat': Users,
  'Materiale Premium': Wrench,
  'Atenție la Detalii': Eye,
  'Respectarea Termenelor': Calendar,
};

const AboutSection = () => {
  return (
    <section id="despre" className="py-24 bg-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-blue-50 to-transparent"></div>
      <div 
        className="absolute right-0 top-1/2 -translate-y-1/2 w-96 h-96 opacity-[0.03]"
        style={{
          backgroundImage: `url(${companyInfo.logo})`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
        }}
      ></div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left - Content */}
          <div>
            <span className="inline-block px-4 py-2 bg-blue-100 text-blue-700 rounded-full text-sm font-semibold mb-6">
              Despre Noi
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-6 leading-tight">
              {aboutContent.title}
            </h2>
            <p className="text-lg text-blue-600 font-medium mb-6">
              {aboutContent.subtitle}
            </p>
            <div className="text-slate-600 leading-relaxed space-y-4 mb-10">
              {aboutContent.description.split('\n\n').map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </div>

            {/* Company info */}
            <div className="flex items-center gap-6 p-6 bg-slate-50 rounded-2xl">
              <img
                src={companyInfo.logo}
                alt={companyInfo.name}
                className="h-16 w-auto"
              />
              <div>
                <h4 className="font-bold text-slate-900">{companyInfo.name}</h4>
                <p className="text-slate-500 text-sm">CUI: {companyInfo.cui}</p>
              </div>
            </div>
          </div>

          {/* Right - Values */}
          <div className="grid sm:grid-cols-2 gap-6">
            {aboutContent.values.map((value, index) => {
              const Icon = iconMap[value.title] || CheckCircle2;
              return (
                <div
                  key={index}
                  className="group p-6 bg-white rounded-2xl shadow-lg shadow-slate-200/50 border border-slate-100 card-hover"
                >
                  <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-blue-500 to-cyan-500 flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-300">
                    <Icon className="text-white" size={26} />
                  </div>
                  <h3 className="text-xl font-bold text-slate-900 mb-3">
                    {value.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed">
                    {value.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
